module.exports = __webpack_public_path__ + "static/icon-speaker-534782b929141e6f7c2c982007bb0cd6.png";